export default __webpack_public_path__ + "static/media/house-7.87bb786d.jpg";